module.exports = __webpack_public_path__ + "img/loading.de8e168c.svg";